/** Custom domain test ids — mirrored in @test-kit CUSTOM_DOMAIN (keep in sync). */
export type DnsRecordTestKey = 'a-host' | 'a-value' | 'cname-host' | 'cname-value';
export const CUSTOM_DOMAIN_TEST_IDS = {
  section: 'custom-domain-section',
  addBtn: 'custom-domain-add-btn',
  setupDialog: 'custom-domain-setup-dialog',
  domainInput: 'custom-domain-domain-field',
  continueBtn: 'custom-domain-continue-btn',
  dnsDoneBtn: 'custom-domain-dns-done-btn',
  verifyBtn: 'custom-domain-verify-btn',
  removeBtn: 'custom-domain-remove-btn',
  retryBtn: 'custom-domain-retry-btn',
  dnsRow: (key: DnsRecordTestKey) => `custom-domain-dns-row-${key}`,
  dnsCopyBtn: (key: DnsRecordTestKey) => `custom-domain-dns-copy-${key}`,
  /** Container of one domain slot (web funnel domain / article domain). */
  slot: (surface: 'web' | 'article') => `custom-domain-slot-${surface}`,
  /** Article-surface twins of `section` / `addBtn` (values unchanged since v2.20.0). */
  articleSection: 'article-domain-section',
  articleAddBtn: 'article-domain-add-btn',
  /** Path-mode panel in the article slot (Task 32 / PRE-009). Provider keys: cloudflare | vercel | netlify | nginx | framer. */
  baseUrl: {
    panel: 'custom-domain-base-url-panel',
    /** On the native <input> (value / readonly / aria-describedby are asserted on it). */
    input: 'custom-domain-base-url-input',
    verifyBtn: 'custom-domain-base-url-verify',
    status: 'custom-domain-base-url-status',
    /** The helper-text element of the input while it shows an error (client or server). */
    error: 'custom-domain-base-url-error',
    disableBtn: 'custom-domain-base-url-disable',
    disableConfirm: 'custom-domain-base-url-disable-confirm',
    snippetTab: (provider: string) => `custom-domain-base-url-tab-${provider}`,
    /** Code block of a provider (Framer: its info text — it has no rule to copy). */
    snippetCode: (provider: string) => `custom-domain-base-url-code-${provider}`,
    snippetCopy: (provider: string) => `custom-domain-base-url-copy-${provider}`,
    robotsLine: 'custom-domain-base-url-robots-line',
    robotsCopy: 'custom-domain-base-url-robots-copy',
    /** Mode-switch report ("Progress" while running, "Last switch" after): failure alert + SDataTable. */
    report: 'custom-domain-base-url-report',
  },
  /** Home page select (D-2, in the article domain section). On the select's root (StyledSelectDropdown FormControl): open it via its combobox. */
  homeAlias: { select: 'custom-domain-home-alias-select' },
} as const;
